const productColors = {
  colorProductAbs: '#5a489c',
  colorProductHyc: '#92499d',
  colorProductIgc: '#0d7baa',
  gradientProductAbs: 'linear-gradient(86deg, var(--gradient-abs-stop-1) 6.76%, var(--gradient-abs-stop-2) 100.88%)',
  gradientProductHyc: 'linear-gradient(86deg, var(--gradient-hyc-stop-1) 6.76%, var(--gradient-hyc-stop-2) 100.88%)',
  gradientProductIgc: 'linear-gradient(86deg, var(--gradient-igc-stop-1) 3.99%, var(--gradient-igc-stop-2) 97.24%)',
  gradientProductHycIgc: 'linear-gradient(86deg, var(--gradient-hyc-igc-stop-1) 3.99%, var(--gradient-hyc-igc-stop-2) 97.24%)',
  gradientCfrTextPages: 'linear-gradient(85deg, #16121c 0%, #443945 100%)',
};

export default productColors;
